import Swal from "sweetalert2";

export const toastOfflineMessage = () => {
  Swal.fire({
    html: "اتصال شما به اینترنت قطع شده است",
    icon: "warning",
    showConfirmButton: false,
  });
}

export const deliverySuccessMessage = (message, timer) => {
  Swal.fire({
    html: message,
    icon: "success",
    timer,
    showConfirmButton: false,
  });
}

export const areYouSureMessage = (
  func,
  html = "از حذف کاربر مطمئنید؟",
  confirmButtonText = "بله مطمئنم"
) => {
  Swal.fire({
    html,
    icon: "warning",
    confirmButtonText,
    showCancelButton: true,
    cancelButtonColor: "#d33",
    confirmButtonColor: "#3085d6",
    cancelButtonText: "خیر",
  }).then((result) => {
    if (result.value) func();
  });
};

